import { getUniqueElements } from "@finway-group/shared/lib/utils/helpers"
import { Button, Card, Table, Tabs } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { generatePath, useHistory } from "react-router-dom"
import { DeliveryNoteLinkModal } from "~Components/modals/DeliveryNoteLink/DeliveryNoteLinkModal"
import { columns } from "~Features/pages/expenses/expenseDetails/LinkedPurchaseOrdersSection"
import { usePurchaseOrdersForLinkingQuery } from "~Features/pages/purchaseOrders/queries/purchaseOrder.queries"
import { useModal } from "~Shared/context/modal.context"
import { RoutePathEnum } from "~Shared/router/RoutePath.enum"
import { useDeliveryNoteQuery } from "../queries/deliveryNote.queries"

const { TabPane } = Tabs

interface LinkedPurchaseOrdersProps {
    deliveryNoteId: string
    disabled: boolean
}
export const LinkedPurchaseOrdersSection = ({ deliveryNoteId, disabled }: LinkedPurchaseOrdersProps) => {
    const { t } = useTranslation()
    const { data: deliveryNote } = useDeliveryNoteQuery(deliveryNoteId)
    const history = useHistory()
    const uniquePurchaseOrders = getUniqueElements(deliveryNote?.lineItems?.map((lineItem) => lineItem.purchaseOrderLink).filter((link) => link !== undefined) || [], "_id")
    const uniqueLinkedPurchaseOrderIds = uniquePurchaseOrders.map((purchaseOrder) => purchaseOrder._id)
    const hasLinkedPos = uniqueLinkedPurchaseOrderIds.length > 0
    const { data } = usePurchaseOrdersForLinkingQuery(
        {
            filter: { _id: { in: uniqueLinkedPurchaseOrderIds } },
        },
        { enabled: hasLinkedPos, keepPreviousData: false },
    )
    const editDisabled = !hasLinkedPos || disabled
    const { docs: purchaseOrders } = data || { docs: [] }
    const { showModal } = useModal()
    const handleManageLinks = () => {
        showModal(DeliveryNoteLinkModal, true, {
            isShowing: true,
            deliveryNoteId,
            selectedPurchaseOrders: uniquePurchaseOrders,
        })
    }
    return (
        <Card className="w-full">
            <div className="mb-10 flex justify-between">
                <h3 className="text-lg font-semibold mb-0">{t("label:linked_to_this_delivery_note")}</h3>
                <Button type="primary" onClick={handleManageLinks} disabled={editDisabled}>
                    {t("action:po_link.manage_links")}
                </Button>
            </div>

            <Tabs defaultActiveKey="purchase-orders" className="mt-10">
                <TabPane tab={t("label:purchase_orders")} key="purchase-orders" className="overflow-x-scroll">
                    <Table
                        columns={columns}
                        dataSource={purchaseOrders}
                        rowKey="_id"
                        pagination={false}
                        size="middle"
                        showHeader={false}
                        onRow={(record) => {
                            const hasReadAccess = record?.metadata?.userAccess?.read
                            return {
                                onClick: () => {
                                    if (hasReadAccess) {
                                        history.push(generatePath(RoutePathEnum.PURCHASE_ORDER_DETAILS_PAGE, { id: record._id }))
                                    }
                                },
                                style: {
                                    cursor: hasReadAccess ? "default" : "not-allowed",
                                },
                            }
                        }}
                        className="w-full"
                    />
                </TabPane>
            </Tabs>
        </Card>
    )
}
